<template>
	<page-content-layout class="page" title="Statistics">
		<div class="page">
			<div class="bar">
				<div class="tools">
					<select-view class="light" label="Område" v-model="statistic" :options="options" :optional="true" />
					<date-select-view class="from light" v-model="from" label="Fra" :optional="true" :controller="$store.state.popupController" />
					<date-select-view class="to light" v-model="to" label="Til" :optional="true" :controller="$store.state.popupController" />
				</div>
				<div class="categories">
					<div v-for="(cat, i) in chart.categories" :key="i" class="item">
						{{ cat }}
						<switch-view class="light" :value="categories.includes(cat)" @input="setCategory(cat, ...arguments)" />
					</div>
				</div>
			</div>
			<apexchart class="chart" type="bar" :options="_chartOptions" :series="_chartSeries" />
		</div>
	</page-content-layout>
</template>

<script>
	import { bus } from '../../bus'

    export default {
		data() {
			return {
				options: [
					{
						label: 'Henvendelser',
						value: 'leads'
					},
					{
						label: 'Præstationer',
						value: 'performance'
					},
					{
						label: 'Salg',
						value: 'sales'
					}
				],
				statistic: 'leads',
				from: (new Date()).format('Y-m-01'),
				to: (new Date()).format('Y-m-d'),
				categories: [],
				chart: {
					categories: [],
					series: []
				}
			};
		},
		watch: {
			statistic(n) {
				this.categories = [];
				this.update();
			},
			from() {
				this.update();
			},
			to() {
				this.update();
			}
		},
		computed: {
			_filter() {
				var r = [];

				for (var i = 0; i < this.chart.categories.length; ++i) {
					if (this.categories.includes(this.chart.categories[i])) {
						r.push(i);
					}
				}

				

				return r;
			},
			_chartOptions() {
				var f = this._filter;

				return {
					chart: {
						id: 'chart'
					},
					xaxis: {
						categories: this.chart.categories.filter(function (item, index) { return f.includes(index) })
					}
				};
			},
			_chartSeries() {
				var f = this._filter;
				var series = JSON.parse(JSON.stringify(this.chart.series));

				for (var i = 0; i < series.length; ++i) {
					series[i].data = series[i].data.filter(function (item, index) { console.log(index, f.includes(index)); return f.includes(index); });
				}

				return series;
			},
			_series() {
				return this.options.find(function (item) { return item.value = self.n; }).series;
			}
		},
		methods: {
			async update() {
				this.chart = (await this.axios.get('/statistics/' + this.statistic + '/?from=' + this.from + '&to=' + this.to)).data;
			},
			setCategory(cat, val) {
				

				if (val) {
					this.categories.push(cat);
				} else {
					var idx = this.categories.indexOf(cat);

					

					if (idx >= 0) {
						this.categories.splice(idx, 1);
					}
				}

				
			}
		},
		created() {
			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.chart.categories = [];
				self.chart.series = [];
			});
		},
		mounted() {
			this.update();
		}
    }
</script>

<style lang="scss">
	.page {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 100%;

		& > .bar {
			background-color: #F0F0F0;
			border-right: 1px solid #CECECE;
			display: grid;
			grid-template-rows: auto 1fr;

			& > .tools {
				padding: 20px;

				& > div {
					margin-bottom: 20px;
				}
			}

			& > .categories {
				border-top: 1px solid #CECECE;
				padding: 20px;
				overflow-y: auto;

				& > .item {
					line-height: 26px;
					position: relative;
					font-size: 12px;

					& > .light {
						position: absolute;
						top: 3px;
						right: 0;
					}
				}
			}
		}

		& > .chart {
			padding: 20px;
		}
	}
</style>